let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dxc4F")).then(() => parcelRequire('bkp4a'));